/**
 * Designed by Junhua on 17/2/16.
 */
import axios from '../http'
import Qs from 'qs'
import vm from '../main'

let urls = {
    login:'/login',    //登陆

    getOrderList:'/orders/getlist',
    getOrderById:'/orders/getone',
    saveOrder:'/orders/save',
    updateOrder:'/orders/update',
    deleteOrder:'/orders/remove',
    getAllOrder:'/orders/getall',
    completeOrder:'/orders/complete',
    olConfirm:'/orders/olConfirm',
    olShip:'/orders/ship',
    cancelOrder:'/orders/cancel',

    getClientList:'/client/getlist',
    getClientById:'/client/getone',
    saveClient:'/client/save',
    updateClient:'/client/update',
    deleteClient:'/client/remove',
    getAllClient:'/client/getall',
    
    getWoList:'/wo/getlist',
    getWoById:'/wo/getone',
    saveWo:'/wo/save',
    updateWo:'/wo/update',
    deleteWo:'/wo/remove',
    getAllWo:'/wo/getall',
    completeWo:'/wo/complete',
    deleveryWo:'/wo/delivery',
    modifyWo:'/wo/modify',
    expWo:'/wo/export',

    getMaterialList:'/material/getlist',
    getMaterialById:'/material/getone',
    saveMaterial:'/material/save',
    updateMaterial:'/material/update',
    deleteMaterial:'/material/remove',
    getAllMaterial:'/material/getall',
    getSupByMat:'/material/supplier',
    saveMatSup:'/material/supplier/save',
    deleteMatSup:'/material/supplier/remove',

    getSupplierList:'/supplier/getlist',
    getSupplierById:'/supplier/getone',
    saveSupplier:'/supplier/save',
    updateSupplier:'/supplier/update',
    deleteSupplier:'/supplier/remove',
    getAllSupplier:'/supplier/getall',

    getWarehouseList:'/warehouse/getlist',
    getWarehouseById:'/warehouse/getone',
    saveWarehouse:'/warehouse/save',
    updateWarehouse:'/warehouse/update',
    deleteWarehouse:'/warehouse/remove',
    getAllWarehouse:'/warehouse/getall',

    getStockinList:'/stockin/getlist',
    getStockinById:'/stockin/getone',
    saveStockin:'/stockin/save',
    updateStockin:'/stockin/update',
    deleteStockin:'/stockin/remove',
    getAllStockin:'/stockin/getall',

    getDeliveryList:'/delivery/getlist',
    getDeliveryById:'/delivery/getone',
    saveDelivery:'/delivery/save',
    updateDelivery:'/delivery/update',
    deleteDelivery:'/delivery/remove',
    getAllDelivery:'/delivery/getall',

    getFormulaList:'/formula/getlist',
    getFormulaById:'/formula/getone',
    saveFormula:'/formula/save',
    updateFormula:'/formula/update',
    deleteFormula:'/formula/remove',
    getAllFormula:'/formula/getall',

    getUserList:'/user/getlist', //获取用户分页列表
    getUserById:'/user/getone', //获取一个用户对象
    saveUser:'/user/save', //新建用户
    updateUser:'/user/update', //更新用户
    deleteUser:'/user/remove',//删除用户
    getAllUser:'/user/getall',
    changePwd:'/user/changePwd',
    
    getSjhz:'/report/sjhz',
    expDelivery:'/delivery/export',
    
    getOrderRecvById:'/orderRecv/getone',
    saveOrderRecv:'/orderRecv/save',
    deleteOrderRecv:'/orderRecv/remove',
    getAllOrderRecv:'/orderRecv/getall',

    getOrderInvoiceById:'/orderInvoice/getone',
    saveOrderInvoice:'/orderInvoice/save',
    deleteOrderInvoice:'/orderInvoice/remove',
    getAllOrderInvoice:'/orderInvoice/getall',

    getCountPriceList:'/countPrice/getlist',
    getCountPriceById:'/countPrice/getone',
    saveCountPrice:'/countPrice/save',
    updateCountPrice:'/countPrice/update',
    deleteCountPrice:'/countPrice/remove',
    getAllCountPrice:'/countPrice/getall',
    copyCountPrice:'/countPrice/copy',
    countPriceGenOrder:'/countPrice/saveToOrder',
    countPriceDoc:'/countPrice/export',

    getLogPriceList:'/logPrice/getlist',
    getLogPriceById:'/logPrice/getone',
    saveLogPrice:'/logPrice/save',
    updateLogPrice:'/logPrice/update',
    deleteLogPrice:'/logPrice/remove',
    getAllLogPrice:'/logPrice/getall',

    getAllDict:'/dict/getall',
    saveDict:'/dict/save',
    updateDict:'/dict/update',
    deleteDict:'/dict/remove',
    getDictById:'/dict/getone',

    getZbList:'/zb/getlist',
    getZbById:'/zb/getone',
    saveZb:'/zb/save',
    updateZb:'/zb/update',
    deleteZb:'/zb/remove',
    getAllZb:'/zb/getall',

    getZbPriceList:'/zbPrice/getlist',
    getZbPriceById:'/zbPrice/getone',
    saveZbPrice:'/zbPrice/save',
    updateZbPrice:'/zbPrice/update',
    deleteZbPrice:'/zbPrice/remove',
    getAllZbPrice:'/zbPrice/getall',

    getMljsList:'/mljs/getlist',
    getMljsById:'/mljs/getone',
    saveMljs:'/mljs/save',
    updateMljs:'/mljs/update',
    deleteMljs:'/mljs/remove',
    getAllMljs:'/mljs/getall',
    copyMljs:'/mljs/copy',

    getPurchaseList:'/purchase/getlist',
    savePurchase:'/purchase/save',
    deletePurchase:'/purchase/remove',
    getAllPurchase:'/purchase/getall',

    getAccRecList:'/accRec/getlist',
    getAccRecById:'/accRec/getone',
    saveAccRec:'/accRec/save',
    updateAccRec:'/accRec/update',
    deleteAccRec:'/accRec/remove',
    getAllAccRec:'/accRec/getall',
    accRecDoc:'/accRec/export',
    accRecSum:'/accRec/summary',

    onlineSummary:'/report/online/summary',//在线订单汇总
    onlineDetail:'/report/online/detail',//在线订单明细
    
}

//包装get
let getMethod = (url,query) => axios.get(url + '?' + Qs.stringify(query))

let postMethod = (url,query) => axios.post(url , query)//包装post

let post = async function(reqUrl,query,selfHandle){
    console.log(reqUrl)
    if('login'.indexOf(reqUrl) == -1 && localStorage.token){//登录api不需要检查token
        if(query){
            query.token = localStorage.token;
        }else{
            query = {
                token : localStorage.token
            }
        }
    }
    let res = null;
    try{//捕捉请求异常并提示错误
        res = await postMethod(urls[reqUrl],query);
    }catch(e){
        vm.$notify({ message: '远程服务器失联了，请检查您的网络！', type: 'error'});
        return null;
    }
    if(res.data.code == '400' && 'login'.indexOf(reqUrl) == -1){//token失效
        vm.$notify({ message: '身份认证失效,请重新登录！', type: 'error'});
        localStorage.clear();
        sessionStorage.hasBar = 0;
        location.href = '/#/login'
        return null;
    }else if(res.data.code != '0'){//其他错误
        if(selfHandle){
            return res;
        }else {
            vm.$notify({ message: res.data.msg, type: 'error'});
            return null;
        }
    }
    else{//正常的情况
        return res;
    }
};

export default {
    post:post,
    url:axios.defaults.baseURL,
}